<template>
    <div class="bg--light h100">
        <div class="login">
            <img src="assets/images/layout/logo-domovio-outline-text-vertical-rgb.svg" class="login__image"
                 alt="logo domovio">

            <div class="login__form">
                <login @logged="logged"/>
            </div>

            <div class="form-copy">
                <a :href="$dmv.env.WEB_DOMAIN + '/registrace'">Založit účet</a>
            </div>
        </div>
    </div>
</template>
<script>
import isUndefined from 'lodash/isUndefined';
import Login from 'domovio-core/src/modules/UserModule/components/Login';

export default {
    components: {Login},
    methods:    {
        logged() {
            const {rt} = this.$route.query;
            if (isUndefined(rt)) this.$router.push({name: 'project-default'});
            else window.location.href = rt;
        }
    }
}
</script>
